import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src="/logo.png" alt="Gestare Contabilidade" className="logo-image" />
        </Link>
        
        {/* Menu Desktop */}
        <nav className="nav-desktop">
          <Link to="/" className="nav-link">Início</Link>
          <Link to="/sobre" className="nav-link">Sobre</Link>
          <Link to="/contato" className="nav-link">Contato</Link>
        </nav>

        {/* Botão do menu mobile */}
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Menu lateral mobile */}
      <nav className={`nav-mobile ${isMenuOpen ? 'active' : ''}`}>
        <div className="nav-mobile-content">
          <Link to="/" className="nav-link" onClick={closeMenu}>Início</Link>
          <Link to="/sobre" className="nav-link" onClick={closeMenu}>Sobre</Link>
          <Link to="/contato" className="nav-link" onClick={closeMenu}>Contato</Link>
        </div>
      </nav>

      {/* Overlay para fechar o menu */}
      {isMenuOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}
    </header>
  );
};

export default Header;
